import { render } from "./MyCkdeitor.vue?vue&type=template&id=01e2489a"
import script from "./MyCkdeitor.vue?vue&type=script&lang=js"
export * from "./MyCkdeitor.vue?vue&type=script&lang=js"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__